import React from "react";
import { Badge, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { SubTitle } from "../../Components/CustomComponents/index";
import { WEB_ROUTES } from "../../constants";
import _ from "lodash";
import EmptyContainer from "../../Components/Container/EmptyContainer";

const TrainingCategories = ({ data = [], loading }) => {
  const navigate = useNavigate();

  return (
    <div>
      <SubTitle text={"Training Categories"} classes="black-text" />
      <Row className={`w-100 mt-2 mb-5`}>
        <div className={`d-flex flex-row flex-wrap gap-2`}>
          {loading ? (
            <div className="w-100 d-flex flex-row justify-content-center">
              <Spinner />
            </div>
          ) : _.isEmpty(data) ? 
          <EmptyContainer text="Data Not Found" classes="my-2" />
          :(
            data?.map((item, index) => (
              <Badge
                key={index}
                as="div"
                pill
                bg="category-bg"
                text="category-text"
                role="button"
                onClick={() => {
                  // console.log(item.categoryName);
                  navigate(`/${WEB_ROUTES.COURSES}`, { state: { item } });
                }}
              >
                {item.name}
              </Badge>
            ))
          )}
        </div>
      </Row>
    </div>
  );
};

export default TrainingCategories;
